<template>
  <div class="main">
    <Sidebar
      :current-keywords="keywords"
      :current-filters="currentFilters"
      :filter-types="filterTypes"
      @search="setKeywords"
      @add-filter="addFilter"
      @remove-filter="removeFilter"
      @remove-all-filters="removeAllFilters"
    />

    <div class="title-bar">
      <a
        class="float-right btn btn-secondary"
        :href="route('admin.companies.create')"
      >
        <span class="icon icon-plus"></span>
        <span class="text">Add New</span>
      </a>
      <h1>Companies</h1>
      <AdminMenu class="pt-2" current="Companies" />
    </div>

    <div class="content p-3">
      <div class="row">
        <div class="col-12">
          <transition name="fade">
            <Alert v-if="hasAlert" :alert="alert" />
          </transition>

          <div class="row d-none d-xl-flex">
            <div class="col-12 text-center mb-3 col-lg-3 text-lg-left mb-lg-0">
              <a
                v-if="items.length > 0"
                href="#"
                @click.prevent="showExportOptions()"
                class="btn btn-info"
              >
                <span class="icon icon-download"></span>
                <span class="text">Export List</span>
              </a>
            </div>
            <div class="col-12 text-center mb-3 col-lg-6 mb-lg-0">
              <Pagination
                class="d-inline-block"
                :total="totalPages"
                :value="parseInt(pagination.current)"
                @input="setCurrentPage"
              />
            </div>
            <div class="col-12 text-center col-lg-3 text-lg-right">
              <PageSize
                :value="parseInt(pagination.per_page)"
                @input="setPerPage"
              />
            </div>
          </div>

          <div class="row">
            <div
              :class="{
                'col-12': !showDetailsPane,
                'col-8 details-pane-open': showDetailsPane,
              }"
            >
              <ListTable
                :items="items"
                :columns="columns"
                :activeColumns="activeColumns"
                :hideNoResults="hideNoResults"
                :hasDetailsPane="showDetailsPane"
                @sort-by="setSort"
                @swap-column="setActiveColumn"
                @item-clicked="setSelectedItem"
              >
                <template v-slot:col_created_at="{ item }">{{
                  item.created_at | moment("MM/DD/YYYY")
                }}</template>
                <template v-slot:col_updated_at="{ item }">{{
                  item.updated_at | moment("MM/DD/YYYY")
                }}</template>
                <template v-slot:list-menu="{ item, id }">
                  <ListMenu
                    :item="item"
                    :id="id"
                    :eventBus="listEvents"
                    section="admin"
                  />
                </template>
              </ListTable>
            </div>
            <div v-if="showDetailsPane" class="col-4 details-pane-wrap mb-3">
              <DetailsPane
                :company="selectedItem"
                section="admin"
                @close="setSelectedItem(null)"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-xl-3">
              <a
                v-if="items.length > 0"
                href="#"
                @click.prevent="showExportOptions()"
                class="btn btn-info"
              >
                <span class="icon icon-download"></span>
                <span class="text">Export List</span>
              </a>
            </div>
            <div class="col-12 col-xl-6 text-center">
              <Pagination
                class="d-inline-block"
                :total="totalPages"
                :value="parseInt(pagination.current)"
                @input="setCurrentPage"
              />
            </div>
            <div class="col-12 col-xl-3 text-center text-xl-right">
              <PageSize
                :value="parseInt(pagination.per_page)"
                @input="setPerPage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import ListingMixin from "mixins/Listing";
import AdminMenu from "../partials/AdminMenu";
import ListMenu from "components/partials/Companies/ListMenu";
import DetailsPane from "components/partials/Companies/DetailsPane";

export default {
  mixins: [DisplaysAlerts, ListingMixin],
  components: {
    AdminMenu,
    ListMenu,
    DetailsPane,
  },
  mounted() {
    this.listEvents.$on("show-details-pane", this.setSelectedItem);
    this.listEvents.$on("show-alert", this.showAlert);
  },
};
</script>
